let placeholderCount = 0;
export default function KiaImagePlaceholder({
  className,
}: {
  className: string;
}) {
  placeholderCount++;

  return (
    <div
      className={`bg-slate-200/50 grid place-content-center ${className || 'aspect-square border border-black'}`}
    >
      <span>Placeholder {placeholderCount}</span>
    </div>
  );
}
